export enum InputTypeEnum {
  MESSAGE = "",
  CONTINUE = "Continue",
  SAY = "Say",
  DO = "Do",
  SNEAK = "Sneak",
  MOVE = "Move",
  FIGHT = "Fight",
  ITEM = "Item",
  FORWARD = "Forward",
  MIXED = "Mixed",
}

export enum ReplyTypeEnum {
  DEFAULT = "Random",
  TEXT = "Text",
  MESSAGE = "",
}

export enum ModelEnum {
  ASTRAL_SPARK = 1,
  CELESTIAL_SURGE = 2,
  ECLIPSE_BLADE = 3,
  STELLA = 4,
  Lyra = 5,
  Luna = 6,
}

export enum ChatSceneTargetType {
  WINNING = 1,
  LOSING = 2,
}
// Astral Spark
// ·底模:ChatGPT 3.5
// ·消耗能量块:1.5个/回复
// 上下文长度: 16k context length
// Celestial Surge
// ·底模:ChatGPT 40
// 消耗能量块:15个/回复
// 。上下文长度: 128k context length
// Eclipse Blade
// ·底模:ChatGPT 4
// 消耗能量块:30个/回复
// 上下文长度:128k context length
// Stella (NSFW)
// 底模:opus-v1.2-7b
// 消耗0.2水晶解锁1段回复
// 。上下文长度: 4k context length
export const ModelList: {
  label: string;
  value: ModelEnum;
  contextLength: string;
  cost: string;
  costType: "crystal" | "powerCube";
  supportLanguage: string[];
  isNsfwSupport: boolean;
  model: string;
  hide?: boolean;
}[] = [
  {
    label: "Astral Spark",
    value: ModelEnum.ASTRAL_SPARK,
    contextLength: "16k",
    cost: "1.5",
    costType: "powerCube",
    model: "gpt-4-turbo",
    isNsfwSupport: false,
    supportLanguage: ["Chats.lang.all"],
  },
  {
    label: "Celestial Surge",
    value: ModelEnum.CELESTIAL_SURGE,
    contextLength: "128k",
    cost: "15",
    costType: "powerCube",
    model: "gpt-4o",
    isNsfwSupport: false,
    supportLanguage: ["Chats.lang.all"],
  },
  // {
  //   label: "Eclipse Blade",
  //   value: ModelEnum.ECLIPSE_BLADE,
  //   contextLength: "128k",
  //   cost: "30",
  //   costType: "powerCube",
  //   isNsfwSupport: false,
  //   supportLanguage: ["Chats.lang.all"],
  // },
  {
    label: "Stella",
    value: ModelEnum.STELLA,
    contextLength: "4k",
    cost: "0.4",
    costType: "crystal",
    isNsfwSupport: true,
    model: "role-play-llama-3",
    supportLanguage: ["Chats.lang.en"],
  },
  // {
  //   label: "Lyra",
  //   value: ModelEnum.Lyra,
  //   contextLength: "12k",
  //   cost: "0.5",
  //   costType: "crystal",
  //   isNsfwSupport: true,
  //   supportLanguage: ["Chats.lang.en"],
  //   hide: true,
  // },
  // {
  //   label: "Luna",
  //   value: ModelEnum.Luna,
  //   contextLength: "8k",
  //   cost: "1",
  //   costType: "crystal",
  //   isNsfwSupport: true,
  //   supportLanguage: ["Chats.lang.en"],
  //   hide: true,
  // },
];

export const DEFAULT_COST = 0.4;

export enum ChatMessageImageType {
  Pose = "Pose",
  Emotion = "Emotion",
}

export enum MateCardPromptType {
  Scenario = 1,
  Greeting = 2,
  Personality = 3,
  Reaction = 4,
}

export enum MateCardFactoryGenerateType {
  Continue = 1,
  Overwrite = 2,
}

export enum ChatSceneScoreType {
  Status = 1,
  Attribute = 2,
}

export enum LanguageModel {
  // // OpenAI
  // ChatGPT4OMini = 1,
  // ChatGPT4 = 2,
  // ChatGPT4o = 3,
  // // Local model
  // RolePlayLlama3 = 4,
  // // DreamGen
  // OpusSM = 5,
  // OpusXL = 6,
  // // Anthropic
  // Claude = 7,
  // // DeepSeek
  // DeepSeek = 8,
  // Aliyun
  QwenFlash = 11,
  // QwenPlus = 9,
  // Google
  // GeminiPro = 10,
  GeminiFlash = 12,
  // QwenCharacter = 13,
  QwenMax = 14,
  Qwen30bA3b = 15,
}

export const LanguageModelRatio = {
  [LanguageModel.QwenFlash]: 0.2, // 入门
  [LanguageModel.Qwen30bA3b]: 0.4, // 轻享
  [LanguageModel.QwenMax]: 1, // 标准
  [LanguageModel.GeminiFlash]: 3, // 进阶
};

export const getLanguageModelRatio = (model: LanguageModel) => {
  return LanguageModelRatio[model] || 1;
};
